const PGAdapter = require('../../common/pg-adapter')

const LOCATION_RELATIONSHIP_RULE_TABLE_NAME = 'avocado.data_location_relationship_rule'
const LOCATION_RELATIONSHIP_RULE_COLUMNS = [
  'id',
  'location_id',
  'relationship_rule_type',
  'relationship_rule',
  'created_at',
  'updated_at'
]

class LocationRelationshipRulePgAdapter extends PGAdapter {
  constructor ({ pgConnection, logger, username }) {
    super(pgConnection,
      LOCATION_RELATIONSHIP_RULE_TABLE_NAME,
      username,
      LOCATION_RELATIONSHIP_RULE_COLUMNS,
      'id',
      {},
      logger
    )
  }
}

module.exports = LocationRelationshipRulePgAdapter
